import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ArbreComposant, ArbreExplorer } from 'src/app/model/arbre/arbre-composant';
import { TreeService } from 'src/app/services/http/tree/tree.service';
import { UtilsService } from 'src/app/services/tools/utils.service';

import { UserService } from 'src/app/services/http/user/user.service';
import { PdfService } from 'src/app/services/tools/pdf/pdf.service';

@Component({
  selector: 'app-current-verif',
  templateUrl: './current-verif.component.html',
  styleUrls: ['./current-verif.component.scss']
})

export class CurrentVerifComponent implements OnInit, OnChanges {

  /** Partie de l'arbre en train d'être parcourue */
  @Input() subTree!: ArbreComposant[];

  /** Evènement emis pour indiquer un changement du sous-arbre */
  @Output() changeComposant = new EventEmitter<ArbreComposant[]>();

   @Output() resetMachine = new EventEmitter<boolean>();

  /** Composant affiché */
  public composant!: ArbreComposant;

  /** Ensemble des enfants du composant en cours d'affichage */
  public children!: ArbreComposant[];

  /** Indicateur pour savoir si il faut afficher le bouton "Suivant"  */
  public showNextButton: boolean = true;

  public showSolvedButton: boolean = false;
  /**
   * L'ID de la réponse choisie le cas échéant
   */
  private checkedAnswerId: any;

  /**
   * Le niveau de preuve choisi en cas de réponse
   */
  private chosenProofLevel!: string;

  /** Permet d'afficher le chemin parcouru*/
  public displayedPath!: string;

  public exploredPaths!: ArbreExplorer[];
  private username!: string;

  constructor(public treeService: TreeService, private utilsService: UtilsService, private userService: UserService, private pdfService: PdfService) { }

  public currentComment: string = '';

  @Input() snMachine!: string;

  private additionnalInfos: any[] = [];

  async ngOnInit(): Promise<void> {
    await this.loadComposant(this.subTree[0]);
    this.userService.sharedUsername.subscribe(username => this.username = username);
    this.setNextButton();
  }

  /**
   * Détermine quels boutons doivent être affichés
   */
  async setNextButton() {
    /** 
     * Composant : pas de bouton suivant ni de boutons resolu */
    // if (this.composant?.type == 'Elément') {
    //   this.showNextButton = false;
    //   this.showSolvedButton = false;
    //   return;
    // }
    /** 
     * Symptome : pas de bouton suivant. 
     * Les boutons resolu sont visible si toutes les possibilités ont été explorées */
    if (this.composant?.type == 'Elément' && this.composant?.children_type != 'Réponse') {
      this.showNextButton = false;
      this.showSolvedButton = !this.hasMoreOptions();
      return;
    }
    /** Type autre que Réponse et plus d'enfants : pas de bouton suivant mais bouton résolu */
    if (this.composant.children_id.length < 1 && this.composant.type != 'Réponse') {
      this.showNextButton = false;
      this.showSolvedButton = true;
      return;
    }
    /** Type Réponse et plus d'enfants : pas de bouton résolu mais bouton suivant */
    if (this.composant.children_id.length < 1 && this.composant.type == 'Réponse') {
      this.showNextButton = true;
      this.showSolvedButton = false;
      return;
    }

    /** Si ce n'est PAS une question = enfant n'est pas une réponse */
    if (this.composant?.children_type != 'Réponse') {
      const parent = await this.treeService.getComposant(this.composant?.parent_id);
      const nextIndex = parent.children_id.indexOf(this.composant?.id.toString()) + 1;
      /** Est ce que le parent à d'autres enfants ? */
      if (nextIndex < parent.children_id.length) {
        this.showNextButton = true;
      } else {
        /** Si le composant n'a plus d'enfants, on affiche le bouton qui permettra de revenir au Symptome*/
        if (this.composant.children_id.length < 1) {
          this.showNextButton = true;
          return;
        }
        this.showNextButton = false;
      }
    } else {
      this.showNextButton = true;
    }
  }

  /**
   * Detection d'un changement du sous-arbre depuis l'extérieur 
   * @param change 
   */
  async ngOnChanges(change: SimpleChanges) {

    /** Un nouveau sous-arbre a été reçu */
    if (change.subTree) {
      this.subTree = change.subTree.currentValue;
      await this.loadComposant(this.subTree[0]);
    }
    /** Un id machine a été reçu */
    if (change.snMachine) {
      this.snMachine = change.snMachine.currentValue;
    }
  }

  /** Gestion des radios buttons de réponses à une question */
  async handleRadio(event: any) {
    var target = event.target;
    /** L'id html du radio bouton est écrit Id (du composant réponse choisi) + S ou W ( degré de certitude ) */
    const realChildId = target.id.substring(0, target.id.length - 1);
    const proofLevel = target.id.substring(target.id.length - 1);
    this.checkedAnswerId = realChildId.toString();
    this.chosenProofLevel = proofLevel;

    /** Une fois une réponse choisie, on peut passer à la vérif suivante */
    this.setNextButton();
  }

  /**
   * Click sur le bouton 'Suivant'
   */
  async nextVerif() {
    /** Une réponse a été choisie ? */
    if (this.checkedAnswerId) {

      const newChild = await this.treeService.getComposant(this.checkedAnswerId);
      this.subTree.unshift(newChild)

      /** La réponse choisie n'a pas d'enfants, c'est une feuille */
      if (newChild.children_id.length < 1) {
        //console.log('no more children, add to checked paths');
        this.addToExploredPaths(this.subTree, this.chosenProofLevel, this.currentComment);
        this.resetAnswerFields();
        await this.loadComposant(newChild);

        return;
      }

      let chosenAnswer = await this.treeService.getChildren(newChild);
      this.subTree.unshift(chosenAnswer[0])

      if (chosenAnswer[0].children_id.length < 1) {
        this.addToExploredPaths(this.subTree, this.chosenProofLevel, this.currentComment);
      } else {
        const infos = {
          nodeId: this.checkedAnswerId,
          proofLevel: this.chosenProofLevel,
          comment: this.currentComment
        }
        this.additionnalInfos.push(infos);
        //console.log('ICI : ' + this.chosenProofLevel + ' / ' + this.currentComment + ' / ' + this.checkedAnswerId );
      }

      this.resetAnswerFields();

      /** Chargement du premier enfant de la réponse choisie */
      await this.loadComposant(chosenAnswer[0]);

    } else {
      /** Dans le cas d'autre chose qu'une réponse, on affiche l'enfant suivant du parent du composant en cours */
      const parent = this.subTree[1];
      const currentIndex = parent.children_id.indexOf(this.composant.id.toString());
      const nextIndex = currentIndex + 1;
      /** Le parent a d'autres enfants à suivre ? */
      if (nextIndex <= parent.children_id.length - 1) {
        const id = parent.children_id[nextIndex];
        this.composant = await this.treeService.getComposant(Number(id));
      } else {
        /** Le parent n'a plus d'autres enfants, on remonte au symptome en cours d'exploration */
        let currentSymptome = this.subTree.find(node => { return node.type == 'Elément' && node.children_type !='Réponse' })!;
        this.resetSubTreeToNode(currentSymptome)
        await this.loadComposant(currentSymptome);
      }
    }
  }

  /**
   * Reset current subTree to a given node
   * @param referenceNode the ArbreComposant to reset to
   */
  resetSubTreeToNode(referenceNode: ArbreComposant) {
    const positionInSubTree = this.subTree.indexOf(referenceNode);
    this.subTree = this.subTree.filter((elt, index) => { return index >= positionInSubTree });
  }

  /**
   * Reset answers fields
   */
  resetAnswerFields() {
    this.checkedAnswerId = undefined;
    this.chosenProofLevel = '';
    this.currentComment = '';
  }

  /** Add a new Path, all the way up to a leaf, to ExploredPaths */
  addToExploredPaths(path: ArbreComposant[], proofLevel: string, comment: string) {
    if (!this.exploredPaths) {
      this.exploredPaths = [];
    }
    var currentSubTree = JSON.parse(JSON.stringify(path)); // Have a copy of current Subtree
    const leaf = new ArbreExplorer(currentSubTree, proofLevel, comment);
    this.exploredPaths.push(leaf);
  }

  /**
   * Ajout d'un composant au sous-arbre et chargement
   * @param composant le composant à ajouter au sous-arbre
   */
  addToSelection(composant: ArbreComposant) {
    this.subTree.unshift(composant);
    this.loadComposant(composant);
  }

  /**
   * Charge le composant à afficher
   * @param element 
   */
  async loadComposant(composant: ArbreComposant) {

    this.composant = composant;

    /** Chargement des enfants */
    this.children = await this.treeService.getChildren(this.composant);

    /** On informe le sous-arbre a changé */
    this.changeComposant.emit(this.subTree);

    /** Mise à jour du bouton 'suivant' */
    this.setNextButton();

    /** Mise à jour du chemin affiché */
    this.updateDisplayPath();
  }

  /**
   * Met à jour la chemin affiché jusqu'au composant en cours
   */
  updateDisplayPath() {
    this.displayedPath = "";
    for (let i = this.subTree.length - 1; i > 0; i--) {
      this.displayedPath += this.subTree[i].label;
      if (i > 0) {
        this.displayedPath += ' > ';
      }
    }
  }

  getNumSeriePrint(): string {
    let numSerie = 'Non renseigné';
    if (this.snMachine) {
      numSerie = this.snMachine;
    }
    return numSerie;
  }


  reversePaths() {
    /** Reverse explored paths to have them going from root of tree to leafs */
    this.exploredPaths.forEach(element => {
      element.path.reverse()
    });
  }

  /**
   * Click sur un bouton de fin d'exploration 
   * @param resolved true if breakdown is solved, false otherwise
   */
  resolvedPanne(resolved: boolean) {

    let numSerie = this.getNumSeriePrint();

    const dateHeure = this.utilsService.getNiceDateHeureFromDate(new Date())

    this.reversePaths();

    this.treeService.recordGuide( numSerie, resolved, dateHeure, this.username, this.exploredPaths, this.additionnalInfos );

    this.pdfService.makePdf( numSerie, resolved, dateHeure, this.username, this.exploredPaths, this.additionnalInfos );

    this.resetTreeExploration();
  }

  resetTreeExploration() {
    this.subTree = [];
    this.exploredPaths = [];
    this.additionnalInfos = [];
    this.snMachine = '';
    this.changeComposant.emit(this.subTree);
    this.resetMachine.emit(true);
  }

  hasBeenExplored(child: ArbreComposant) {
    if (!this.exploredPaths || this.exploredPaths.length < 1) {
      return false;
    }

    let boll: boolean = false;

    this.exploredPaths.forEach(element => {
      if (element.path.find(elt => { return elt.id == child.id })) {
        boll = true;
      }
    });

    return boll;
  }

  /** Know if current componant has untested children (not appearing in explored paths)  */
  hasMoreOptions() {
    if (!this.exploredPaths || this.exploredPaths.length < 1) {
      return true;
    }

    let childrenExplored: boolean[] = [];
    /** Fill an array of 'true', one true by children found in explored paths */
    this.composant.children_id.forEach(id => {
      for (let explored of this.exploredPaths) {
        if (explored.hasBeenExplored(id)) {
          childrenExplored.push(true);
        }
      }
    })
    /** If array of 'true' has size of children, they have all been explored */
    return childrenExplored.length != this.composant.children_id.length;
  }
}
